export default {
    showVariationsModal: {
        copy: 'Redacción',
        contentVariation: 'Variante de contenido',
        chosenContent: 'Contenido elegido',
        chosenContentPlaceholder: 'Por favor, introduzca',
        continue: 'Continuar',
        generateNewContent: 'Generar nuevo contenido',
        type: 'Tipo:',
        contentTitle: 'Título:',
        descriptionLabel: 'Descripción:',
        keywordsLabel: 'Palabras clave:',
        writingTone: 'Tono de redacción:',
        context: 'Contexto:',
        cancel: 'Cancelar',
    },
};
